import { Component } from '@angular/core';
import { Auth } from '@angular/fire/auth';
import { LocalSettingsService } from '../../../lib/services/local-settings.service';
import { ConnectionType } from '../../../lib/models/tools.models';
import { Router, ActivatedRoute } from '@angular/router';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

@Component({
  selector: 'ms-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  standalone: false,
})
export class LoginComponent {
  private static readonly unauthorizedMessages: Record<string, string> = {
    'unauthorized-user':
      "Votre utilisateur n'est pas reconnu pour l'usage de cette application. Si vous pensez que c'est une erreur, contactez votre administrateur.",
  };

  public unauthorizedMessage: string | null = null;

  constructor(
    private localSettings: LocalSettingsService,
    private auth: Auth,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    const unauthorizedKey = this.route.snapshot?.queryParamMap?.get('unauthorized');
    this.unauthorizedMessage = unauthorizedKey
      ? LoginComponent.unauthorizedMessages[unauthorizedKey] ?? null
      : null;
  }

  public async openOAuthApi(): Promise<void> {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: 'select_account' });
    try {
      await signInWithPopup(this.auth, provider);
      this.localSettings.setConnectionType(ConnectionType.OAUTH);
      await this.router.navigate(['oAuthLogin']);
    } catch {
      this.localSettings.setConnectionType(ConnectionType.BASIC);
    }
  }
}
